import {
  GetNotificationOutDto,
  GetNotificationInDto,
} from "../../../types/notification";

export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_ERROR = "GET_NOTIFICATION_ERROR";
export const RESET_GET_NOTIFICATION = "RESET_GET_NOTIFICATION";

export interface GetNotification {
  type: typeof GET_NOTIFICATION;
  payload: GetNotificationOutDto;
}

export interface GetNotificationSuccess {
  type: typeof GET_NOTIFICATION_SUCCESS;
  payload: GetNotificationInDto | null;
}

export interface GetNotificationError {
  type: typeof GET_NOTIFICATION_ERROR;
  payload: boolean | string;
}

export interface ResetGetNotification {
  type: typeof RESET_GET_NOTIFICATION;
  payload: null;
}

export interface State {
  data: GetNotificationInDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | GetNotification
  | GetNotificationSuccess
  | GetNotificationError
  | ResetGetNotification;
